import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import { AuthProvider } from './context/AuthContext.jsx'
import './index.css'
// Capture beforeinstallprompt at startup — see lib/pwaInstall.js.
import './lib/pwaInstall.js'
// Staff screens reload themselves when a new version is deployed, so /staff
// is never stuck on an old bundle. Customer screens are untouched.
import { installStaffAutoReload } from './lib/staffAutoReload.js'

installStaffAutoReload()

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
